/**
 * @ngInject
 */

function detach () {

    function link (scope, elem, attrs) {
        
        // var stickyElement = document.querySelector('.header__menu');
        // var anchorElement = document.querySelector('.header__anchor');
        var controlElement = document.querySelector(attrs.detachControl);

        function onWindowScroll (event) {
            var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
            if ((controlElement.offsetTop - scrollTop) > window.innerHeight) {
                elem[0].classList.add("detach");
            }
            else {
                elem[0].classList.remove("detach");
            }            
        }
        window.addEventListener('scroll', onWindowScroll);
        onWindowScroll();
    }

    return {
        restrict: 'A',
        link: link
    };
}